// "Metti Jammo sulla Home": capire dove ci troviamo e cosa si puo' fare.
//
// - Android con Chrome: il browser stesso offre l'installazione. Ci arriva
//   l'evento "beforeinstallprompt", lo teniamo da parte e lo usiamo quando la
//   persona tocca "Installa": compare la finestra di sistema, due tocchi.
// - iPhone: Apple non permette di installare da un pulsante. Si possono solo
//   spiegare i passi (Condividi, poi "Aggiungi alla schermata Home").
// - Dentro un'altra app (Instagram, Facebook...): da li' la Home non si
//   raggiunge, serve prima aprire la pagina nel browser.
//
// Questo file va importato all'avvio (index.js): l'evento di Chrome arriva
// una volta sola, spesso prima che la pagina della serata sia disegnata.

const CHIAVE = 'jammo_home';   // 'non-ora' | 'fatto'

let promptRinviato = null;
const ascoltatori = new Set();
const avvisa = () => ascoltatori.forEach(f => { try { f(); } catch (e) { /* niente */ } });

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Niente banner automatico di Chrome: la proposta la fa Jammo, nel
    // momento giusto (dopo "Partecipo") e con le sue parole.
    e.preventDefault();
    promptRinviato = e;
    avvisa();
  });
  window.addEventListener('appinstalled', () => {
    promptRinviato = null;
    segnaHome('fatto');
    avvisa();
  });
}

export function ascoltaInstallazione(f) {
  ascoltatori.add(f);
  return () => ascoltatori.delete(f);
}

// Aperta dall'icona sulla Home: non c'e' niente da proporre.
export function giaSullaHome() {
  if (typeof window === 'undefined') return false;
  return window.navigator.standalone === true
    || !!window.matchMedia?.('(display-mode: standalone)').matches;
}

const ua = () => (typeof navigator !== 'undefined' ? navigator.userAgent || '' : '');

// L'iPad recente si presenta come un Mac: lo riconosce lo schermo touch.
export function piattaforma() {
  const u = ua();
  if (/iPhone|iPad|iPod/i.test(u)) return 'ios';
  if (/Macintosh/i.test(u) && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1) return 'ios';
  if (/Android/i.test(u)) return 'android';
  return 'altro';
}

// Browser dentro un'altra app. Elenco di nomi che queste app scrivono nel
// proprio "biglietto da visita" (user agent); su Android "; wv)" vuol dire
// pagina aperta dentro un'app, non in Chrome. Non e' un elenco perfetto: se
// un'app non si dichiara, la trattiamo come un browser normale.
export function dentroUnAltraApp() {
  const u = ua();
  if (/FBAN|FBAV|FB_IAB|FBIOS|Instagram|LinkedInApp|Line\/|TikTok|musical_ly|BytedanceWebview|Snapchat|Pinterest|Twitter|GSA\/|WhatsApp/i.test(u)) return true;
  if (piattaforma() === 'android' && /; wv\)/.test(u)) return true;
  return false;
}

// Sull'iPhone anche Chrome, Firefox ed Edge sanno aggiungere alla Home (da
// iOS 16.4), ma il pulsante Condividi sta in un posto diverso da Safari.
export function browserIphone() {
  const u = ua();
  if (/CriOS/i.test(u)) return 'chrome';
  if (/FxiOS|EdgiOS|OPiOS/i.test(u)) return 'altro';
  return 'safari';
}

export function puoInstallareSubito() {
  return !!promptRinviato;
}

// La finestra di sistema di Chrome. Restituisce true se la persona ha detto si'.
export async function installaOra() {
  const p = promptRinviato;
  if (!p) return false;
  promptRinviato = null;   // si puo' usare una volta sola
  avvisa();
  try {
    await p.prompt();
    const scelta = await p.userChoice;
    if (scelta?.outcome === 'accepted') { segnaHome('fatto'); return true; }
  } catch (e) { console.error(e); }
  return false;
}

export function statoHome() {
  try { return localStorage.getItem(CHIAVE); } catch (e) { return null; }
}

export function segnaHome(valore) {
  try { localStorage.setItem(CHIAVE, valore); } catch (e) { /* niente */ }
  avvisa();
}

// Ha senso proporlo? Solo su telefono, solo se non e' gia' sulla Home.
export function homeProponibile() {
  return piattaforma() !== 'altro' && !giaSullaHome();
}
